import React from 'react';
import style from '../storeChecksCopy.module.scss';
import cn from 'classnames';
import FullWidthModal from '../../common/Modal/FullWidthModal';
import { LABEL } from '../../../veriables';

const OpenTableCheckModal = ({isOpenCheck, onCloseTable, isLandScape, serverAppTheme, loading, children}) => {


    return (
        <FullWidthModal
        isOpen={isOpenCheck}
        loading={loading}
        isModalCenter={true}
        style={{backgroundColor:serverAppTheme?.popUp_bg, height: '100%'}}
        customClass={cn('h-100')}
        customClass2='h-100 w-100'
        customWidth={true}
        noBackground
      >
        <div className="col-12 justify-content-center align-items-center position-relative text-center p-0">
          <div
            className={cn('col-12 text-center fw-600 fs_18', style.moretitlebg)}
          >
            {LABEL().ADD_TABLE}        
          </div>
          <div className="mb-0">
            {children}
          </div>
        </div>
      </FullWidthModal>       
    )
}

export default OpenTableCheckModal;